module.exports = __webpack_public_path__ + "static/media/ic_to_sell_gold.56dfc7b9.svg";